import { isEmpty } from '@/src/utils/generalUtils'
import { logError } from '@/src/utils/logError'

/**
 * Routes a GTM event to the right sink: iOS bridge, Android bridge, or the web
 * dataLayer. No filtering here — each analytics hook is responsible for emitting
 * exactly the attributes its event needs (per the GA Events sheet).
 */
export const pushGtmEvent = (finalPayload: any = {}) => {
    try {
        if (typeof window !== 'undefined' && !isEmpty(finalPayload)) {
            if (window?.webkit?.messageHandlers?.GAInterface?.postMessage) {
                window.webkit.messageHandlers.GAInterface.postMessage({
                    event: finalPayload.event,
                    parameters: finalPayload
                })
            } else if (window?.MobileApp?.postMessage) {
                window.MobileApp.postMessage(finalPayload.event, JSON.stringify(finalPayload))
            } else if (window.dataLayer && Array.isArray(window.dataLayer)) {
                window.dataLayer.push(finalPayload)
            }
        }
    } catch (error) {
        logError('pushGtmEvent', error)
    }
}
